import { dateProvider } from '@utils';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ShowMoreButton } from '../../../shared/WidgetShared.styles';
import { TaskCard } from '../TaskCard';

import { EmptyTasks, RestDay } from './EmptyMessages';
import { Wrapper } from './SelectedDayTasksList.styles';

import { usePlanificationTimeline } from '@/hooks/usePlanificationTimeline';

export const SelectedDayTasksList = () => {
  const { t } = useTranslation('StudentDashboardTranslations');
  const { selectedDate, sortedPlanificationActivitiesByDate } = usePlanificationTimeline();
  const [showMore, setShowMore] = useState(false);
  const activities = sortedPlanificationActivitiesByDate[selectedDate];

  if (!activities || activities.length === 0) {
    if (!dateProvider.isToday(selectedDate)) {
      return <RestDay />;
    }
    return <EmptyTasks />;
  }

  const showedActivities = showMore ? activities : activities.slice(0, 5);
  return (
    <Wrapper>
      {showedActivities.map(activity => (
        <TaskCard key={activity.activity?._id} task={activity} />
      ))}
      {activities.length > 5 && (
        <ShowMoreButton type="text" onClick={() => setShowMore(!showMore)}>
          {showMore ? t('SHOW_LESS') : t('SHOW_MORE')}
        </ShowMoreButton>
      )}
    </Wrapper>
  );
};
